export default {
      id: "icon--day-ticket-usage",
      viewBox: "0 0 32 21",
      url: __webpack_public_path__ + "redesign-sprite.svg#icon--day-ticket-usage",
      toString: function () {
        return this.url;
      }
    }